export default __webpack_public_path__ + "static/media/bnr-mob-v2.4b219ab4.png";